import Button from "components/shared/Button";
import { FC, useState } from "react";
import house from "assets/project-house.png";
import house2 from "assets/house-pics.png";
import { ContactModal } from "pages/enterprises/components/HeroSection";

export const HeroSection: FC = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };
  return (
    <div className="relative w-full bg-custom-gradient md:bg-transparent">
      <div className="relative mt-0 md:mt-0">
        <div className="hidden md:block">
          <img src={house} alt="house" className="w-full" />
        </div>
        <div className="block md:hidden ">
          <img src={house2} alt="house" className="w-full pt-52  xs:pt-80" />
        </div>
      </div>
      <div className=" flex flex-col justify-center items-center gap-8 referral-container write-up absolute top-0 md:top-24 left-0 right-0 py-8 px-4 md:px-16">
        <div className="flex flex-col gap-6 md:gap-8 md:w-[740px] text-center">
          <p className="text-blueShades-4 text-5xl font-SatoshiBold md:w-[550px] m-auto">
            Build your project with confidence.
          </p>
          <p className="text-ashShade-16 text-xl md:text-lg font-SatoshiMedium md:w-[660px] m-auto">
            Build from anywhere with tools and support that deliver smart
            reporting, quality assurance, effective budget controls, and robust
            risk management
          </p>
        </div>
        <div className="flex flex-col">
          <a
            href={`https://auth.${process.env.REACT_APP_DOMAIN}/signin`}
            rel="noopener noreferrer"
          >
            <Button
              label="Create a Project"
              style={{
                backgroundColor: "#023061",
                borderColor: "#023061",
              }}
            />
          </a>
        </div>
      </div>
      {modal && <ContactModal closer={toggleModal} />}
    </div>
  );
};
